import {
    GET_FAQS,
    GET_FAQ_DETAIL,
    UPDATE_FAQ,
    DELETE_FAQS,
    GET_SUB_FAQS,
    API_RESPONSE_SUCCESS,
    API_RESPONSE_ERROR,
} from "./actionType";

const initialState = {
    faqs: [],
    subFaqs: [],
    currentFaq: null,
    error: {},
    loading: false
};

const FAQ = (state = initialState, action) => {
    console.log("FAQ Reducer - Current State:", state);
    console.log("FAQ Reducer - Action:", action.type, action.payload);
    
    switch (action.type) {
        case GET_FAQS:
        case GET_FAQ_DETAIL:
        case UPDATE_FAQ:
        case DELETE_FAQS:
        case GET_SUB_FAQS:
            return {
                ...state,
                loading: true,
                error: null
            };

        case API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case GET_FAQS:
                    return {
                        ...state,
                        faqs: action.payload.data || [],
                        loading: false,
                        error: null
                    };
                case GET_FAQ_DETAIL:
                    return {
                        ...state,
                        currentFaq: Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data,
                        loading: false,
                        error: null
                    };
                case UPDATE_FAQ:
                    // Log the update payload
                    console.log('Update FAQ payload:', action.payload);
                    
                    // Safety check for payload data
                    if (!action.payload.data) {
                        console.warn('Update FAQ: No data in payload');
                        return {
                            ...state,
                            loading: false
                        };
                    }

                    // Safety check for _id
                    if (!action.payload.data._id) {
                        console.warn('Update FAQ: No _id in payload data');
                        return {
                            ...state,
                            loading: false,
                            currentFaq: action.payload.data
                        };
                    }
                    
                    // Don't try to update faqs array if it's empty or invalid
                    if (!Array.isArray(state.faqs) || state.faqs.length === 0) {
                        return {
                            ...state,
                            loading: false,
                            currentFaq: action.payload.data
                        };
                    }

                    // Update with all safety checks in place
                    return {
                        ...state,
                        loading: false,
                        currentFaq: action.payload.data,
                        faqs: state.faqs.map(faq => {
                            if (!faq || !faq._id) return faq;
                            return faq._id === action.payload.data._id ? action.payload.data : faq;
                        })
                    };
                case DELETE_FAQS:
                    return {
                        ...state,
                        loading: false,
                        error: null
                    };
                case GET_SUB_FAQS:
                    console.log("GET_SUB_FAQS Success - Payload:", action.payload);
                    // Make sure we're setting the subFaqs array correctly
                    const subFaqsData = Array.isArray(action.payload.data) ? action.payload.data : [];
                    return {
                        ...state,
                        subFaqs: subFaqsData,
                        loading: false,
                        error: null
                    };
                default:
                    return state;
            }

        case API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case GET_FAQS:
                case GET_FAQ_DETAIL:
                case UPDATE_FAQ:
                case DELETE_FAQS:
                case GET_SUB_FAQS:
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false
                    };
                default:
                    return state;
            }

        default:
            return state;
    }
};

export default FAQ; 